import React from 'react';
import { IconProps } from '.';

const SvgColoredBarChart = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#5AC27C'
        d='M1.333 9.333C1.333 8.597 1.93 8 2.667 8h2.666c.737 0 1.334.597 1.334 1.333V20c0 .736-.597 1.333-1.334 1.333H2.667A1.333 1.333 0 0 1 1.333 20V9.333Z'
      />
      <path
        fill='#F4847D'
        d='M9.333 13.333c0-.736.597-1.333 1.334-1.333h2.666c.737 0 1.334.597 1.334 1.333V20c0 .736-.597 1.333-1.334 1.333h-2.666A1.333 1.333 0 0 1 9.333 20v-6.667Z'
      />
      <path
        fill='#7E96F9'
        d='M17.333 5.333c0-.736.597-1.333 1.334-1.333h2.666c.737 0 1.334.597 1.334 1.333V20c0 .736-.597 1.333-1.334 1.333h-2.666A1.333 1.333 0 0 1 17.333 20V5.333Z'
      />
    </svg>
  );
};

export default SvgColoredBarChart;
